<template>
  <div>
    <h3>Cashback</h3>
    <p>CASHBACK - es un programa de reembolso de dinero a través de bonificaciones, ante una serie negativa.</p>
    <h5>Reglas y condiciones</h5>
    <ol>
        <li>El bono Cashback se acredita en la cuenta cada {{bonus.days}} días.</li>
        <li>El monto de la bonificación Cashback equivale al {{bonus.percent || 0}}% del monto perdido durante en los {{bonus.days}} días anteriores.</li>
        <li>Próxima acreditación {{formatDate(bonus.nextDate)}}.</li>
        <li>Al calcular el bono, sólo se tienen en cuenta las apuestas realizadas en la sección "Casino" del sitio.</li>
        <li>Las reglas de la promoción pueden ser modificadas</li>
    </ol>
  </div>
</template>
<script>
  import utils from '../../../../../../../_common/utils'

  export default {
    name: 'bonus-rules-cashback-es',
    props: {
      bonus: {
        type: Object,
        required: true
      }
    },
    methods: {
      formatDate(date) {
        return utils.formatDateTime(date, 'MM/DD HH:mm');
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-cashback/es.vue